import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Button,
  CardContent,
  TextField,
  Typography,
  Stack,
  Avatar,
  MenuItem,
  CircularProgress
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from '../../../Api';
import { useTranslation } from 'react-i18next';
import GooglePlaces from 'src/components/GooglePlaces';

export default function CompanyProfile({ handleClose, user, refreshAdmin }) {
  console.log('user=====', user);
  const roleName = user?.role?.role_name;
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [name, setname] = useState('');
  const [about_me, setabout_me] = useState(user?.about_me ? user?.about_me : null);
  const [phone, setPhone] = useState(user?.contact_no ? user?.contact_no : '');
  const [address, setaddress] = useState(null);
  const [companysize, setcompanysize] = useState(null);
  const [companylist, setcompanylist] = useState([]);
  const [categorylist, setcategorylist] = useState([]);
  const [companycategory, setcompanycategory] = useState(null);
  const [companydata, setcompanydata] = useState(null);
  const [websiteurl, setwebsiteurl] = useState('');
  const [linkedinurl, setlinkedinurl] = useState('');
  const [file, setfile] = useState({ image: companydata?.avatar, file: '' });
  console.log('=======', user);
  useEffect(() => {
    if (user && user?.location) {
      setaddress({
        address: user?.location,
        lat: user?.lat || null,
        lon: user?.lon || null,
        country: user?.country || null,
        city: user?.city || null
      });
    }
  }, []);

  console.log('company data=======', companydata?.avatar);

  useEffect(() => {
    getCompanyCategory();
    if (user) {
      getCompanyDetail(user);
    }
  }, [user?.id]);

  useEffect(() => {
    setfile({ image: companydata?.avatar });
  }, [companydata]);

  function SaveProfile() {
    const token = localStorage.getItem('token');

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('user_id', user?.id);
    formdata.append('name', name);
    about_me && formdata.append('about_me', about_me);
    phone && formdata.append('contact_no', phone);
    if (address) {
      formdata.append('location', address?.address);
      formdata.append('country', address?.country);
      formdata.append('city', address?.city);
      formdata.append('lat', address?.lat);
      formdata.append('lon', address?.lon);
    }

    // if (file && file.file) {
    //   formdata.append('avatar', file.file);
    // }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);

    fetch(api.updateProfile, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const response = JSON.parse(body);

        if (status === 200 || status === 201) {
          refreshAdmin();
          handleClose();
        } else {
          setalert({ visible: true, message: 'Something went wrong' });
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => setloading(false));
  }

  const [objAfter, setobjAfter] = useState({
    name: companydata?.name,
    file: false
  });
  const handlecompanysize = (event) => {
    setcompanysize(event.target.value);
  };

  const handlecompanycategory = (event) => {
    setcompanycategory(event.target.value);
  };

  function getCompanyDetail(id) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    const params = new URLSearchParams();
    params.append('id', id);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(`${api.company_profile_list}?${params.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          console.log('result data of company ===>', result.data);
          setcompanydata(result?.data);
        } else {
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  }
  function getCompanyCategory() {
    // setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(api.get_comapny_categories, requestOptions)
      // fetch(`${api.company_profile_list}?${params.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          console.log('result data of company ===>', result.data);
          setcategorylist(result?.data);
        } else {
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        // setloading(false);
      });
  }

  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t('Company Profile')}
      </Typography>

      {!loading && (
        <CardContent>
          <Stack
            mb={2}
            direction={{ xs: 'column' }}
            style={{ display: 'flex', flexDirection: 'row' }}
            className="image_center"
          >
            <Box
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {file && (
                <Avatar
                  alt="Remy Sharp"
                  src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
                  sx={{ width: 80, height: 80 }}
                  className="image_center"
                />
                // <Avatar
                //   alt="Profile Image"
                //   src={objAfter.file ? file.image : `${file.image}?v=${Date.now()}`} // Append timestamp only when needed
                //   sx={{ width: 80, height: 80, marginBottom: 5 }}
                //   className="image_center"
                // />
              )}
              {/* <Button
                style={{
                  width: !file ? 80 : null,
                  height: !file ? 80 : 30,
                  borderRadius: !file ? 40 : 20,
                  marginTop: 10,
                  marginBottom: 10,
                  fontSize: 12
                }}
                disabled={roleName?.toLowerCase() == 'user' ? true : false}
                variant={file ? 'outlined' : 'outlined'}
                component="label"
              >
                {t('EditProfile.buttons.0')}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => {
                    setobjAfter({
                      file: true
                    });
                    setfile({
                      image: URL.createObjectURL(e.target.files[0]),
                      file: e.target.files[0]
                    });
                  }}
                />
              </Button> */}
            </Box>
          </Stack>
          <Grid container spacing={2} className="top_column">
            <>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  fullWidth
                  disabled={true}
                  value={companydata?.num_of_employees_id?.range}
                  label={'Company Size (Employees)'}
                  // onChange={handlecompanysize}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                ></TextField>
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  // select
                  value={companydata?.company_category?.name}
                  label={'Company Category'}
                  onChange={handlecompanycategory}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                ></TextField>
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  value={companydata?.contact_no}
                  label={'Contact No'}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                ></TextField>
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  label={'Website'}
                  value={companydata?.website}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  label={'LinkedIn Url'}
                  value={companydata?.linkedin}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={12} sm={12} md={12}>
                <TextField
                  disabled={true}
                  id="outlined-error-helper-text"
                  fullWidth
                  label={'Describtion'}
                  type="text"
                  value={about_me || companydata?.description}
                  variant="outlined"
                  display="inline"
                  multiline
                  rows={4}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          </Grid>
        </CardContent>
      )}

      {loading && (
        <Box
          py={5}
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: 1
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          {t('EditProfile.buttons.2')}
        </LoadingButton>
      </Box>
    </Box>
  );
}
